
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import * as reportCss from './DetailReport.css.js';

const ReportCalibrate = ({ setReportMap, beginDate, endDate }) => {
  const history = useHistory();
  const cancellationToken = useCancellationToken();
  const [ complete, setComplete ] = useState(null);
  const [ imminent, setImminent ] = useState(null);
  const [ excess, setExcess ] = useState(null);
  const [ detail, setDetail ] = useState({});

  const getCalibrateData = useCallback(async (beginDate, endDate) => {
    customAxiosGetFunction(history, '/api/calibration/calibrationCnt', {params: {'beginDate': beginDate, 'endDate': endDate}})
      .then(response => {
        setComplete(response['complete']);
        setImminent(response['imminent']);
        setExcess(response['excess']);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [])

  const handleChangeDetail = useCallback((x, value) => {
    setDetail(detail => {
      return {
        ...detail,
        [x]: value
      }
    })
  }, [])

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return
    }

    getCalibrateData(beginDate, endDate);
  }, [beginDate, endDate, cancellationToken])

  useEffect(() => {
    setReportMap(reportMap => {
      return {
        ...reportMap,
        'calibrate': {
          ...reportMap.calibrate,
          'complete': complete,
          'imminent': imminent,
          'excess': excess
        },
        'detail': {
          ...reportMap.detail,
          'calibrate': Object.keys(detail).map(x => { return detail[x] })
        }
      }
    })
  }, [complete, imminent, excess, detail])

  useEffect(() => () => cancellationToken.cancel(), []);

  if (!complete || !imminent || !excess) {
    return null;
  }

  return (
    <>
      
      <reportCss.CalibrateTitleBar>
        <span>5. 교정관리</span>
      </reportCss.CalibrateTitleBar>
      <reportCss.CalibrateContent>
        <div className="mainContent">
          <table>
            <tbody>
              <tr>
                <td>대상기간 중 교정실시</td>
                <td>{complete.length}기</td>
                <td>기기번호</td>
                <td style={{'width': '420px'}}>{complete.join(', ')}</td>
              </tr>
              <tr>
                <td>교정임박(1개월 이내)</td>
                <td>{imminent.length}기</td>
                <td>기기번호</td>
                <td style={{'width': '420px'}}>{imminent.join(', ')}</td>
              </tr>
              <tr>
                <td>교정기간초과</td>
                <td style={{'color': '#ff0000'}}>{excess.length}기</td>
                <td>기기번호</td>
                <td style={{'width': '420px', 'color': '#ff0000'}}>{excess.join(', ')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="subContent">
          <table>
            <thead>
              <tr>
                <th>교정 특기사항</th>
              </tr>
            </thead>
            <tbody>
              {
                [...Array(2).keys()].map((x) => {
                  return (
                    <tr key={`detail_${x}`}>
                      <td><input type="text"
                                className="inputText"
                                onChange={({target}) => { handleChangeDetail(x, target.value) }} /></td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </reportCss.CalibrateContent>
    </>
  )
}

export default React.memo(ReportCalibrate);